import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Delete, Edit } from "@mui/icons-material";
import {
  IconButton,
  Button,
  Box,
  Typography,
  Paper,
  Table,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  TextField,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import Popup from "../Layouts/Popup/Popup";
import axios from "axios";
import CommonDelete from "../CommonActions/CommonDelete";
import { useDispatch, useSelector } from "react-redux";
import { AllCompanysDetails } from "../../redux/action/Company&User/AllCompanys";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/system";
import Dialog from "@mui/material/Dialog";
import { toast } from "react-toastify";
import PageLoader from "../CommonActions/PageLoader";
import { GetTokenFunc } from "../../utils/GetToken";
import GetBalanceComp from "./GetComapnyBalance";
import LastPurchaseDate from "./LastPurchaseDate";
import LastSellDate from "./LastSellDate";
import {
  setCompanyListingCohort,
  getCompanyListingCohort,
} from "../../constants/companyListingCohort";
import * as XLSX from "xlsx/xlsx.mjs";
import { useFetchMemberShipPlan } from "../Dashboard/useMembershipplan";
import { useCategories } from "../../Hooks/useCategories";

const recyclebin = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/Recyclebin/recyclebin.png';


export let Category = "";
export let CompanyStatus = "";
export let Membership = "";
export let Page = "";
export let SelectedCompany = "";
export let DateFilter = "";
export let CompanyListingSearch = "";
/** ISO yyyy-MM-dd for GetAllCompanys calendar filter (company createdAt range). */
export let CalendarStartingDate = "";
export let CalendarEndingDate = "";

function sanitizeXlsxCell(value) {
  if (value == null) return "";
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : "";
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? "" : value.toISOString();
  }
  return String(value).replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g, "");
}

function formatLeadsOnboardingStatus(x) {
  const status = x?.companyOnboardingStatus;
  if (!status || status === "UNVERIFIED" || status === "EMAIL") {
    return "EMAIL VERIFICATION";
  }
  if (status === "BANK_DETAILS") return "PAN_DETAILS";
  return String(status).replace(/_/g, " ");
}

function formatLeadsPlanLabel(x) {
  if (x?.companyOnboardingStatus !== "ONBOARDING_COMPLETE") return "--";
  if (!x?.memberships?.length) return "--";
  const last = x.memberships[x.memberships.length - 1];
  return (
    last?.MembershipPlan?.PlanName ||
    (last?.Membership === "basic"
      ? "Standard"
      : last?.Membership === "advance"
        ? "Advance"
        : last?.Membership || x?.ChoosedPlan) ||
    "--"
  );
}

function formatLeadsCommissionPct(x) {
  if (x?.companyOnboardingStatus === "ONBOARDING_COMPLETE" && x?.memberships?.length) {
    const last = x.memberships[x.memberships.length - 1];
    // Show the platform commission % the company onboarded at (captured on the
    // membership plan snapshot), NOT the plan's GST — GST is 18% for everyone and
    // was being shown here by mistake.
    const commission = last?.MembershipPlan?.commissionPercentage;
    return commission != null && commission !== "" ? `${commission}%` : "--";
  }
  return "--";
}

function leadsOnboardedDateStr(x) {
  const d =
    x?.memberships?.at(-1)?.MembershipStartDate != null
      ? new Date(x.memberships.at(-1).MembershipStartDate)
      : new Date(x?.createdAt);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-GB");
}

function leadsExpiresDateStr(x) {
  const raw =
    x?.memberships?.at(-1)?.MembershipExpiryDate ??
    x?.latestMembership?.MembershipExpiryDate;
  if (raw == null) return "";
  const d = new Date(raw);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-GB");
}

const CompanyListing = ({ listingVariant, pageTitle } = {}) => {
  const isMembersListing = listingVariant === "members";
  const { categoryOptions } = useCategories();
  const { data: membershipPlans } = useFetchMemberShipPlan();
  const [companyTypes, setCompanyTypes] = useState([]);
  const [listingSearchInput, setListingSearchInput] = useState("");
  const [listingSearchDebounced, setListingSearchDebounced] = useState("");
  const StyledPagination = styled(Pagination)({
    "& .MuiPaginationItem-root": {
      color: "#1e1e1e",
      fontFamily: "Inter, sans-serif",
      fontSize: "14px",
      fontWeight: 500,
      minWidth: "32px",
      height: "32px",
      margin: "0 2px",
    },
    "& .MuiPaginationItem-root.Mui-selected": {
      backgroundColor: "#1e1e1e",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#1e1e1e",
      },
    },
    "& .MuiPaginationItem-root:hover": {
      backgroundColor: "#f5f7ff",
    },
    "& .MuiPagination-ul li:first-child button::after": {
      content: "'First'",
      fontFamily: "Inter, sans-serif",
      fontWeight: 500,
      fontSize: "12px",
      color: "#1e1e1e",
      marginLeft: "4px",
    },
    "& .MuiPagination-ul li:last-child button::before": {
      content: "'Last'",
      fontFamily: "Inter, sans-serif",
      fontWeight: 500,
      fontSize: "12px",
      color: "#1e1e1e",
      marginRight: "4px",
    },
    "& .MuiPaginationItem-icon": {
      color: "#1e1e1e",
      fontSize: "18px",
    },
  });

  const [id, setId] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [category, setCategory] = useState("");
  const [activeTab, setActiveTab] = useState(2);
  const [content, setContent] = useState("");
  const [companies, setCompanies] = useState();
  const [companystatus, setCompanystatus] = useState(() =>
    listingVariant === "members" ? "ONBOARDING_COMPLETE" : ""
  );
  const [membership, setMembership] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  // --- MFA (email OTP) gate for company deletion ---
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [otpSending, setOtpSending] = useState(false);
  const [otpVerifying, setOtpVerifying] = useState(false);
  const [otpMaskedEmail, setOtpMaskedEmail] = useState("");
  const [otpResendIn, setOtpResendIn] = useState(0);
  const deleteCompanyIdRef = useRef("");
  const otpVerifyingRef = useRef(false);
  const [AllCompanyName, setAllCompanyName] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [date, setDate] = useState("");
  const [rangeStart, setRangeStart] = useState("");
  const [rangeEnd, setRangeEnd] = useState("");
  const [totalProducts, setTotalProducts] = useState([]);
  const [totalMembers, setTotalMembers] = useState([]);
  const [defaultAmount, setDefaultAmount] = useState("");
  const [error, setError] = useState(false);
  const [companyIdDefaulte, setCompanyIdDefaulte] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [initialPaginationCount, setInitialPaginationCount] = useState(
    currentPage || 1
  );
  const [leadsExportLoading, setLeadsExportLoading] = useState(false);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { AllCompany, loading } = useSelector((state) => state.AllCompany);

  useEffect(() => {
    if (AllCompany && AllCompany?.finalCount !== undefined) {
      setInitialPaginationCount(AllCompany?.finalCount);
    }
  }, [AllCompany?.finalCount]);

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleCloses = () => {
    setOpen(false);
    setError(false);
  };

  Category = category;
  CompanyStatus = companystatus;
  Membership = membership;
  Page = currentPage;
  SelectedCompany = selectedCompany;
  DateFilter = date;
  CompanyListingSearch = listingSearchDebounced;
  CalendarStartingDate = rangeStart;
  CalendarEndingDate = rangeEnd;

  const listingHeading =
    pageTitle ||
    (listingVariant === "leads"
      ? "Leads"
      : listingVariant === "members"
        ? "Live members"
        : "User & Company");

  // Step 1: ask the backend to email a one-time code to the acting admin.
  const requestDeleteOtp = async ({ resend = false } = {}) => {
    const companyId = deleteCompanyIdRef.current || (id ? String(id) : "");
    if (!companyId) return;
    setOtpSending(true);
    try {
      const res = await axios.post(
        `/api/v1/admin/RequestCompanyDeleteOtp/${companyId}`,
        {},
        {
          headers: {
            authorization: `Bearer ${GetTokenFunc()}`,
            "Content-Type": "application/json",
          },
        }
      );
      setOtpMaskedEmail(res?.data?.maskedEmail || "");
      setOtpModalOpen(true);
      setOtpResendIn(30);
      toast.success(
        resend
          ? "A new verification code has been sent to your email."
          : res?.data?.message || "Verification code sent to your email."
      );
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
          "Could not send the verification code. Please try again."
      );
    } finally {
      setOtpSending(false);
    }
  };

  // Step 2: submit the code; the company is deleted only if the backend verifies it.
  const confirmDeleteWithOtp = async () => {
    if (otpVerifyingRef.current) return;
    const companyId = deleteCompanyIdRef.current || (id ? String(id) : "");
    const code = String(otpValue || "").trim();
    if (!companyId) {
      toast.error("Company not selected. Please try again.");
      return;
    }
    if (!/^\d{6}$/.test(code)) {
      toast.error("Enter the 6-digit code sent to your email.");
      return;
    }
    otpVerifyingRef.current = true;
    setOtpVerifying(true);
    try {
      await axios.post(
        `/api/v1/admin/DeleteCompanyById/${companyId}`,
        { otp: code },
        {
          headers: {
            authorization: `Bearer ${GetTokenFunc()}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Company deleted successfully.");
      setOtpModalOpen(false);
      setOtpValue("");
      setOtpMaskedEmail("");
      deleteCompanyIdRef.current = "";
      dispatch(
        AllCompanysDetails(category, companystatus, membership, currentPage)
      );
    } catch (err) {
      const data = err?.response?.data || {};
      const remaining =
        typeof data.remainingAttempts === "number"
          ? ` ${data.remainingAttempts} attempt(s) left.`
          : "";
      toast.error((data.message || "Verification failed.") + remaining);
      // Max attempts exceeded / lock → close and force a fresh request.
      if (err?.response?.status === 403) {
        setOtpModalOpen(false);
        setOtpValue("");
      }
    } finally {
      otpVerifyingRef.current = false;
      setOtpVerifying(false);
    }
  };

  useEffect(() => {
    const cohort =
      listingVariant === "leads"
        ? "leads"
        : listingVariant === "members"
          ? "members"
          : "";
    setCompanyListingCohort(cohort);
    dispatch(
      AllCompanysDetails(category, companystatus, membership, currentPage)
    );
  }, [
    dispatch,
    category,
    companystatus,
    membership,
    selectedCompany,
    date,
    currentPage,
    listingVariant,
    listingSearchDebounced,
    rangeStart,
    rangeEnd,
  ]);

  const filterByCompany = async () => {
    await axios
      .get(`product/get_allproducts_bycompany`, { withCredentials: true })
      .then((res) => {
        setAllCompanyName(res.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    filterByCompany();
  }, []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get("/company_type/get_companyTypes");
        const raw = res?.data;
        const list = Array.isArray(raw)
          ? raw
          : Array.isArray(raw?.body)
            ? raw.body
            : [];
        if (!cancelled) {
          setCompanyTypes(
            [...list].sort((a, b) =>
              String(a?.CompanyTypeName || "").localeCompare(
                String(b?.CompanyTypeName || ""),
                undefined,
                { sensitivity: "base" }
              )
            )
          );
        }
      } catch {
        if (!cancelled) setCompanyTypes([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      setListingSearchDebounced(listingSearchInput.trim());
    }, 400);
    return () => clearTimeout(t);
  }, [listingSearchInput]);

  useLayoutEffect(() => {
    setCurrentPage(1);
  }, [
    category,
    companystatus,
    membership,
    selectedCompany,
    date,
    listingSearchDebounced,
    rangeStart,
    rangeEnd,
  ]);

  const activeMembershipPlans = React.useMemo(() => {
    const list = Array.isArray(membershipPlans) ? membershipPlans : [];
    const active = list.filter((p) => p?.isActive !== false);
    return active.length ? active : list;
  }, [membershipPlans]);

  const handleDelete = () => {
    // Don't delete on confirm — first require an emailed OTP (MFA).
    setIsDeleteModalOpen(false);
    requestDeleteOtp();
  };

  const handleClose = () => {
    setIsDeleteModalOpen(false);
  };

  // Countdown that re-enables the "Resend code" action.
  useEffect(() => {
    if (otpResendIn <= 0) return;
    const t = setTimeout(() => setOtpResendIn((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [otpResendIn]);

  const handleEditButtonClick = (id) => {
    // Tag the origin so the sidebar keeps the correct menu highlighted:
    // companylanding is shared by Leads and Members. Without this hint the
    // sidebar always falls back to Members -> Live Members. Include a
    // "from" query so the detail view can route the back button correctly.
    const search = listingVariant === "leads" ? "?from=leads" : listingVariant === "members" ? "?from=members" : "";
    navigate(`/admindashboard/companylanding/${id}${search}`);
  };

  const handleCompanyChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedCompany(selectedValue);
  };

  const GetAllTotalProductsCount = async () => {
    await axios
      .get(`/api/v1/admin/GetAllTotalProductsCount`, {
        headers: {
          authorization: `Bearer ${GetTokenFunc()}`,
        },
      })
      .then((res) => {
        setTotalProducts(res.data);
      })
      .catch((err) => {});
  };

  const GetAllTotalUserCount = async () => {
    await axios
      .get(`/api/v1/admin/GetAllTotalUserCount`, {
        headers: {
          authorization: `Bearer ${GetTokenFunc()}`,
        },
      })
      .then((res) => {
        setTotalMembers(res.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (!isMembersListing) return;
    GetAllTotalProductsCount();
    GetAllTotalUserCount();
  }, [isMembersListing]);

  const handleButtonClick = (companyId) => {
    handleClickOpen();
    setCompanyIdDefaulte(companyId);
  };

  const handleExportLeadsToExcel = async () => {
    if (listingVariant !== "leads") return;
    setLeadsExportLoading(true);
    try {
      const cohort = encodeURIComponent(getCompanyListingCohort() || "");
      const cat = encodeURIComponent(category ?? "");
      const st = encodeURIComponent(companystatus ?? "");
      const mem = encodeURIComponent(membership ?? "");
      const sel = encodeURIComponent(selectedCompany ?? "");
      const dt = encodeURIComponent(date ?? "");
      const rs = encodeURIComponent(rangeStart ?? "");
      const re = encodeURIComponent(rangeEnd ?? "");
      const search = encodeURIComponent(listingSearchDebounced ?? "");
      const headers = {
        authorization: `Bearer ${GetTokenFunc()}`,
      };
      const buildUrl = (pageNum) =>
        `/api/v1/admin/GetAllCompanys?CompanyCategoty=${cat}&CompanyStatus=${st}&Membership=${mem}&SelectedCompany=${sel}&DateFilter=${dt}&StartingDate=${rs}&EndingDate=${re}&page=${pageNum}&limit=100&Search=${search}&CompanyCohort=${cohort}`;

      const firstRes = await axios.get(buildUrl(1), {
        withCredentials: true,
        headers,
      });
      const data1 = firstRes?.data || {};
      const totalPages = Math.max(
        1,
        parseInt(String(data1?.finalCount || "1"), 10) || 1
      );
      let allCompanies = [...(data1?.Companys || [])];

      for (let p = 2; p <= totalPages; p += 1) {
        const res = await axios.get(buildUrl(p), {
          withCredentials: true,
          headers,
        });
        const chunk = res?.data?.Companys || [];
        if (!chunk.length) break;
        allCompanies = allCompanies.concat(chunk);
      }

      const columnHeaders = [
        "Sr No",
        "Company ID",
        "Company name",
        "Email",
        "Contact",
          "CUID",
        "Status",
        "Company type",
        "Onboarded",
        "Expires",
        "Plan",
        "Commission %",
        "Created at",
      ];

      const dataRows = allCompanies.map((x, i) => {
        const email = x?.email ?? x?.Email ?? "";
        const contact = x?.contact ?? x?.phone ?? x?.Phone ?? "";
        const createdAt = x?.createdAt
          ? new Date(x.createdAt).toLocaleString("en-IN")
          : "";
        return [
          i + 1,
          sanitizeXlsxCell(x?._id),
          sanitizeXlsxCell(x?.companyName),
          sanitizeXlsxCell(email),
          sanitizeXlsxCell(contact),
          sanitizeXlsxCell(x?.CUID),
          sanitizeXlsxCell(formatLeadsOnboardingStatus(x)),
          sanitizeXlsxCell(x?.category),
          sanitizeXlsxCell(leadsOnboardedDateStr(x)),
          sanitizeXlsxCell(leadsExpiresDateStr(x)),
          sanitizeXlsxCell(formatLeadsPlanLabel(x)),
          sanitizeXlsxCell(formatLeadsCommissionPct(x)),
          sanitizeXlsxCell(createdAt),
        ];
      });

      const metaRows = [
        ["Leads export"],
        [`Exported at: ${new Date().toLocaleString("en-IN")}`],
        [`Total rows: ${dataRows.length} · Uses current filters.`],
        [],
        columnHeaders,
      ];
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(metaRows);
      const firstDataRowIndex = metaRows.length;
      dataRows.forEach((row, idx) => {
        XLSX.utils.sheet_add_aoa(ws, [row], {
          origin: { r: firstDataRowIndex + idx, c: 0 },
        });
      });
      XLSX.utils.book_append_sheet(wb, ws, "Leads");
      const stamp = new Date().toISOString().replace(/[:.]/g, "-");
      XLSX.writeFile(wb, `leads-export-${stamp}.xlsx`);
      toast.success(`Exported ${dataRows.length} lead(s) to Excel.`);
    } catch (err) {
      console.error(err);
      toast.error("Failed to export leads. Please try again.");
    } finally {
      setLeadsExportLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      if (defaultAmount.trim() === "") {
        setError(true);
      } else {
        setError(false);

        const response = await axios.post(
          `/api/v1/admin/AdminCompanyDetails/CreateNewDefaulteCase`,
          {
            companyId: companyIdDefaulte,
            amount: defaultAmount,
            status: true,
          },
          {
            headers: {
              authorization: `Bearer ${GetTokenFunc()}`,
            },
          }
        );

        if (response && response.data) {
          toast.success("Amount Added successfully", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          console.error("No data received after saving.");
        }

        handleCloses();
      }
    } catch (error) {
      console.error("Error while saving default amount:", error);
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        height: "auto",
        width: "100%",
        maxWidth: "100vw",
        backgroundColor: "#fafbfc",
        borderRadius: 1.5,
        padding: { xs: 1, sm: 2 },
      }}
    >
      <Box sx={{pt: 1, pb: 3, pl: 1}}>
        <Typography variant="h4">{listingHeading}</Typography>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, minmax(0, 1fr))",
            md: "repeat(auto-fill, minmax(168px, 1fr))",
          },
          gap: { xs: 1.5, sm: 2 },
          marginBottom: 2,
          backgroundColor: "#fff",
          padding: { xs: 1, sm: 2 },
          borderRadius: 1,
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          width: "100%",
          maxWidth: "100%",
          boxSizing: "border-box",
        }}
      >
        <Box sx={{ minWidth: 0, gridColumn: { xs: "1 / -1", md: "span 2" } }}>
          <Typography sx={TypoStyle}>Search</Typography>
          <TextField
            fullWidth
            size="small"
            placeholder="Search by company name…"
            value={listingSearchInput}
            onChange={(e) => setListingSearchInput(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: "#6b7280", fontSize: 20 }} />
                </InputAdornment>
              ),
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                fontFamily: "Inter, sans-serif",
                fontSize: "14px",
                backgroundColor: "#fff",
              },
            }}
          />
        </Box>

        <Box sx={{ minWidth: 0 }}>
          <Typography sx={TypoStyle}>Company type</Typography>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            style={{
              width: "100%",
              maxWidth: "100%",
              padding: "8px 12px",
              border: "1px solid #e1e5e9",
              borderRadius: "6px",
              fontSize: "14px",
              fontFamily: "Inter, sans-serif",
              backgroundColor: "#fff",
              boxSizing: "border-box",
            }}
          >
            <option value="">All company types</option>
            {companyTypes.map((ct) => {
              const id = ct?._id != null ? String(ct._id) : "";
              if (!id) return null;
              const name = ct?.CompanyTypeName || id;
              return (
                <option key={id} value={id}>
                  {name}
                </option>
              );
            })}
          </select>
        </Box>

        {listingVariant !== "leads" && (
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={TypoStyle}>Member</Typography>
            <select 
              onChange={handleCompanyChange} 
              value={selectedCompany}
              style={{
                width: "100%",
                maxWidth: "100%",
                padding: "8px 12px",
                border: "1px solid #e1e5e9",
                borderRadius: "6px",
                fontSize: "14px",
                fontFamily: "Inter, sans-serif",
                backgroundColor: "#fff",
                boxSizing: "border-box",
              }}
            >
              <option value="">All Members</option>
              {AllCompanyName.map((name, index) => (
                <option key={index} value={name?.companyName}>
                  {name?.companyName}
                </option>
              ))}
            </select>
          </Box>
        )}

        {listingVariant !== "members" && (
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={TypoStyle}>Status</Typography>
            <select
              value={companystatus}
              onChange={(e) => setCompanystatus(e.target.value)}
              style={{
                width: "100%",
                maxWidth: "100%",
                padding: "8px 12px",
                border: "1px solid #e1e5e9",
                borderRadius: "6px",
                fontSize: "14px",
                fontFamily: "Inter, sans-serif",
                backgroundColor: "#fff",
                boxSizing: "border-box",
              }}
            >
              <option value="">All Status</option>
              <option value="EMAIL">Email Verification</option>
              <option value="GST">GST Details</option>
              <option value="BANK_DETAILS">Pan Details</option>
              <option value="TNC">T&C</option>
              <option value="PAYMENT">Membership Plans</option>
              <option value="UNDER_REVIEW">Under Review</option>
              {listingVariant !== "leads" && (
                <option value="ONBOARDING_COMPLETE">Onboarding Complete</option>
              )}
            </select>
          </Box>
        )}

        {listingVariant !== "leads" && (
          <Box sx={{ minWidth: 0 }}>
            <Typography sx={TypoStyle}>Membership</Typography>
            <select
              value={membership}
              onChange={(e) => setMembership(e.target.value)}
              style={{
                width: "100%",
                maxWidth: "100%",
                padding: "8px 12px",
                border: "1px solid #e1e5e9",
                borderRadius: "6px",
                fontSize: "14px",
                fontFamily: "Inter, sans-serif",
                backgroundColor: "#fff",
                boxSizing: "border-box",
              }}
            >
              <option value="">All plans</option>
              {activeMembershipPlans.map((plan) => {
                const id = plan?._id != null ? String(plan._id) : "";
                if (!id) return null;
                const label = plan?.PlanName || plan?.PlanType || id;
                return (
                  <option key={id} value={id}>
                    {label}
                  </option>
                );
              })}
            </select>
          </Box>
        )}

        <Box sx={{ minWidth: 0 }}>
          <Typography sx={TypoStyle}>Period</Typography>
          <select 
            value={date} 
            onChange={(e) => setDate(e.target.value)}
            disabled={Boolean(rangeStart || rangeEnd)}
            style={{
              width: "100%",
              maxWidth: "100%",
              padding: "8px 12px",
              border: "1px solid #e1e5e9",
              borderRadius: "6px",
              fontSize: "14px",
              fontFamily: "Inter, sans-serif",
              backgroundColor: (rangeStart || rangeEnd) ? "#f3f4f6" : "#fff",
              opacity: (rangeStart || rangeEnd) ? 0.75 : 1,
              boxSizing: "border-box",
            }}
          >
            <option value="">All Time</option>
            <option value="7">7 Days</option>
            <option value="15">15 Days</option>
            <option value="30">1 Month</option>
            <option value="90">3 Months</option>
            <option value="180">6 Months</option>
            <option value="360">1 Year</option>
            <option value="1080">3 Years</option>
            <option value="1800">5 Years</option>
          </select>
        </Box>

        {(listingVariant === "leads" || listingVariant === "members") && (
          <>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={TypoStyle}>Created from</Typography>
              <TextField
                id="company-filter-start-date"
                type="date"
                size="small"
                fullWidth
                value={rangeStart}
                onChange={(e) => setRangeStart(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px",
                    backgroundColor: "#fff",
                  },
                }}
              />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={TypoStyle}>Created to</Typography>
              <TextField
                id="company-filter-end-date"
                type="date"
                size="small"
                fullWidth
                value={rangeEnd}
                onChange={(e) => setRangeEnd(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px",
                    backgroundColor: "#fff",
                  },
                }}
              />
            </Box>
            <Box
              sx={{
                minWidth: 0,
                display: "flex",
                alignItems: "flex-end",
                gridColumn: { xs: "1 / -1", sm: "auto" },
              }}
            >
              <Button
                type="button"
                variant="outlined"
                size="small"
                disabled={!rangeStart && !rangeEnd}
                onClick={() => {
                  setRangeStart("");
                  setRangeEnd("");
                }}
                sx={{
                  textTransform: "none",
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 600,
                  height: "40px",
                }}
              >
                Clear dates
              </Button>
            </Box>
          </>
        )}
      </Box>

      <Box 
        sx={{ 
          backgroundColor: "#fff",
          borderRadius: 1,
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          overflow: "hidden"
        }}
      >
        <Box sx={{ 
          padding: { xs: 1, sm: 2 },
          borderBottom: "1px solid #e1e5e9",
          backgroundColor: "#f8f9fa",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1.5,
        }}>
          <Box sx={{
            display: "inline-flex",
            alignItems: "center",
            backgroundColor: "#1e1e1e",
            color: "#fff",
            padding: "6px 12px",
            borderRadius: "20px",
            fontSize: "13px",
            fontFamily: "Inter, sans-serif",
            fontWeight: 500,
          }}>
            {AllCompany instanceof Object ? (
              `Total Members: ${AllCompany?.allCompanySCount || 0}`
            ) : (
              "Total Members: 0"
            )}
          </Box>
          {listingVariant === "leads" && (
            <Button
              type="button"
              variant="contained"
              disabled={leadsExportLoading}
              onClick={handleExportLeadsToExcel}
              sx={{
                textTransform: "none",
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
                fontSize: "13px",
                backgroundColor: "#166534",
                color: "#fff",
                borderRadius: "8px",
                px: 2,
                py: 0.75,
                "&:hover": { backgroundColor: "#14532d" },
                "&:disabled": { backgroundColor: "#94a3b8", color: "#fff" },
              }}
            >
              {leadsExportLoading ? (
                <>
                  <CircularProgress size={18} sx={{ color: "#fff", mr: 1 }} />
                  Exporting…
                </>
              ) : (
                "Export to Excel"
              )}
            </Button>
          )}
        </Box>
        <div>
          {AllCompany?.Companys?.length <= 0 ? (
            <Box sx={setBox}>
              <img
                src={recyclebin}
                alt="No data"
                style={{ height: "64px", width: "64px", opacity: 0.5 }}
              />
              <Typography sx={empty}>No companies found</Typography>
            </Box>
          ) : (
            <Box
              sx={{
                width: "100%",
                overflowX: "auto",
                "&::-webkit-scrollbar": {
                  height: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#f1f1f1",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#c1c1c1",
                  borderRadius: "3px",
                },
              }}
            >
              {loading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "400px",
                  }}
                >
                  <PageLoader />
                </Box>
              ) : (
                <TableContainer sx={TableContainerStyle}>
                  <Table stickyHeader aria-label="company table">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ ...TableTitleStyle, minWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell sx={{ ...TableTitleStyle, minWidth: "250px" }}>
                          Member
                        </TableCell>
                        <TableCell sx={TableTitleStyle}>Status</TableCell>
                        <TableCell sx={TableTitleStyle}>Company type</TableCell>
                        {isMembersListing && (
                          <>
                            <TableCell sx={{ ...TableTitleStyle, textAlign: 'center' }}>
                              Products
                            </TableCell>
                            <TableCell sx={{ ...TableTitleStyle, textAlign: 'center' }}>
                              Users
                            </TableCell>
                          </>
                        )}
                        <TableCell sx={TableTitleStyle}>Onboarded</TableCell>
                        <TableCell sx={TableTitleStyle}>Expires</TableCell>
                        <TableCell sx={TableTitleStyle}>Plan</TableCell>
                        <TableCell sx={{ ...TableTitleStyle, textAlign: 'center' }}>
                          Commission
                        </TableCell>
                        {isMembersListing && (
                          <>
                            <TableCell sx={{ ...TableTitleStyle, textAlign: 'right' }}>
                              Purchase
                            </TableCell>
                            <TableCell sx={{ ...TableTitleStyle, textAlign: 'right' }}>
                              Last Purchase
                            </TableCell>
                            <TableCell sx={{ ...TableTitleStyle, textAlign: 'right' }}>
                              Sale
                            </TableCell>
                            <TableCell sx={{ ...TableTitleStyle, textAlign: 'right' }}>
                              Last Sale
                            </TableCell>
                          </>
                        )}
                        <TableCell sx={{ ...TableTitleStyle, textAlign: 'center', minWidth: "160px" }}>
                          Admin Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    {AllCompany?.Companys?.map((x, i) => {
                      return (
                        <TableRow key={i} hover>
                          <TableCell sx={{ ...TextStyleCommon, minWidth: "50px" }}>
                            <Typography sx={{ fontFamily: "Inter, sans-serif", fontSize: "13px", color: "#6b7280" }}>
                              {i + 1}
                            </Typography>
                          </TableCell>
                          <TableCell sx={{ ...TextStyleCommon, minWidth: "250px" }}>
                            <Box sx={{ 
                              display: "flex", 
                              alignItems: "center", 
                              gap: 1,
                              minWidth: "250px"
                            }}>
                              <img
                                src={x?.CompanyAvatar?.url}
                                alt=""
                                style={{ 
                                  height: "32px", 
                                  width: "32px", 
                                  borderRadius: "50%",
                                  border: "1px solid #e1e5e9"
                                }}
                              />
                              <Box>
                                <Typography sx={{ 
                                  fontFamily: "Inter, sans-serif", 
                                  fontWeight: 500,
                                  fontSize: "12px",
                                  color: "#1a1a1a"
                                }}>
                                  {x?.companyName}
                                </Typography>
                                <Typography sx={{ 
                                  fontSize: "11px",
                                  color: "#6b7280",
                                  fontFamily: "Inter, sans-serif"
                                }}>
                                  ID: {x?._id}
                                </Typography>
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell sx={TextStyleCommon}>
                            <Box sx={{
                              backgroundColor: x?.companyOnboardingStatus === "ONBOARDING_COMPLETE" ? "#dcfce7" : "#fef3c7",
                              color: x?.companyOnboardingStatus === "ONBOARDING_COMPLETE" ? "#166534" : "#92400e",
                              padding: "4px 8px",
                              borderRadius: "12px",
                              fontSize: "11px",
                              fontWeight: 500,
                              textAlign: "center",
                              display: "inline-block",
                              fontFamily: "Inter, sans-serif"
                            }}>
                              {formatLeadsOnboardingStatus(x)}
                            </Box>
                          </TableCell>
                          <TableCell sx={TextStyleCommon}>
                            <Typography sx={{ fontFamily: "Inter, sans-serif", fontSize: "13px", color: "#6b7280" }}>
                              {x?.category}
                            </Typography>
                          </TableCell>
                          {isMembersListing && (
                            <>
                              <TableCell sx={{ ...TextStyleCommon, textAlign: 'center' }}>
                                <Typography sx={{ fontFamily: "Inter, sans-serif", fontSize: "13px", color: "#6b7280" }}>
                                  {totalProducts
                                    .filter((product) => product?.company === x?._id)
                                    .reduce((acc, product) => acc + (product.productCount || 0), 0)}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{ ...TextStyleCommon, textAlign: 'center' }}>
                                <Typography sx={{ fontFamily: "Inter, sans-serif", fontSize: "13px", color: "#6b7280" }}>
                                  {totalMembers
                                    .filter((member) => member?.company === x?._id)
                                    .reduce((acc, member) => acc + (member.Users || 0), 0)}
                                </Typography>
                              </TableCell>
                            </>
                          )}
                          <TableCell sx={TextStyleCommon}>
                            <Typography sx={{ fontFamily: "Inter, sans-serif", fontSize: "13px", color: "#6b7280" }}>
                              {x?.memberships?.at(-1)?.MembershipStartDate
                                ? new Date(x?.memberships?.at(-1)?.MembershipStartDate).toLocaleDateString("en-GB")
                                : new Date(x?.createdAt).toLocaleDateString("en-GB")}
                            </Typography>
                          </TableCell>
                          <TableCell sx={TextStyleCommon}>
                            <Typography sx={{ fontFamily: "Inter, sans-serif", fontSize: "13px", color: "#6b7280" }}>
                              {x?.memberships?.at(-1)?.MembershipExpiryDate
                                ? new Date(x?.memberships?.at(-1)?.MembershipExpiryDate).toLocaleDateString("en-GB")
                                : new Date(x?.latestMembership?.MembershipExpiryDate).toLocaleDateString("en-GB")}
                            </Typography>
                          </TableCell>
                          <TableCell sx={TextStyleCommon}>
                            {x?.companyOnboardingStatus === "ONBOARDING_COMPLETE" ? (
                              x?.memberships?.length ? (
                                (() => {
                                  const planName = x.memberships[x.memberships.length - 1]?.MembershipType;
                                  const isStarter = planName === "starter";
                                  const isGrowth = planName === "growth";
                                  const isEnterprise = planName === "enterprise";
                                  return (
                                <Box sx={{
                                  backgroundColor: isStarter ? "#e0f2fe" : isGrowth ? "#f3e8ff" : isEnterprise ? "#ee9b00" : "#f3e8ff",
                                  color: isStarter ? "#0369a1" : isGrowth ? "#7c3aed" : isEnterprise ? "#000000" : "#0369a1",
                                  padding: "4px 8px",
                                  borderRadius: "12px",
                                  fontSize: "11px",
                                  fontWeight: 500,
                                  textAlign: "center",
                                  display: "inline-block",
                                  fontFamily: "Inter, sans-serif",
                                  textTransform: "capitalize"
                                }}>
                                  {planName || "--"}
                                </Box>
                                  );
                                })()
                              ) : (
                                <Typography sx={{ fontFamily: "Inter, sans-serif", fontSize: "13px", color: "#6b7280" }}>
                                  --
                                </Typography>
                              )
                            ) : (
                              <Typography sx={{ fontFamily: "Inter, sans-serif", fontSize: "13px", color: "#6b7280" }}>
                                --
                              </Typography>
                            )}
                          </TableCell>
                          <TableCell sx={{ ...TextStyleCommon, textAlign: 'center' }}>
                            <Typography sx={{ fontFamily: "Inter, sans-serif", fontSize: "13px", color: "#6b7280" }}>
                              {formatLeadsCommissionPct(x)}
                            </Typography>
                          </TableCell>
                          {isMembersListing && (
                            <>
                              <TableCell sx={{ ...TextStyleCommon, textAlign: 'right' }}>
                                <GetBalanceComp id={x?._id} Purchase={true} />
                              </TableCell>
                              <TableCell sx={{ ...TextStyleCommon, textAlign: 'right' }}>
                                <LastPurchaseDate companyId={x?._id} />
                              </TableCell>
                              <TableCell sx={{ ...TextStyleCommon, textAlign: 'right' }}>
                                <GetBalanceComp id={x?._id} Sell={true} />
                              </TableCell>
                              <TableCell sx={{ ...TextStyleCommon, textAlign: 'right' }}>
                                <LastSellDate companyId={x?._id} />
                              </TableCell>
                            </>
                          )}
                          <TableCell sx={{ ...TextStyleCommon, textAlign: 'center', minWidth: "160px" }}>
                            <Box sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: 1,
                              flexWrap: "nowrap",
                              padding: "4px",
                            }}>
                              {/* View/Edit Button */}
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<Edit fontSize="small" />}
                                sx={{
                                  textTransform: "none",
                                  borderColor: "#1e1e1e",
                                  color: "#1e1e1e",
                                  fontSize: "10px",
                                  fontFamily: "Inter, sans-serif",
                                  fontWeight: 500,
                                  minWidth: "65px",
                                  height: "30px",
                                  borderRadius: "6px",
                                  padding: "4px 8px",
                                  "&:hover": {
                                    backgroundColor: "#eff6ff",
                                    borderColor: "#1e1e1e",
                                    color: "#1e1e1e",
                                  },
                                }}
                                onClick={() => {
                                  handleEditButtonClick(x._id);
                                  setId(x._id);
                                }}
                              >
                                View
                              </Button>

                              {/* Delete Button */}
                              <IconButton 
                                size="small" 
                                sx={{ 
                                  color: "#1e1e1e",
                                  backgroundColor: "#f7f7f7",
                                  border: "1px solid #1e1e1e",
                                  borderRadius: "6px",
                                  width: "30px",
                                  height: "30px",
                                  padding: "4px",
                                  "&:hover": { 
                                    backgroundColor: "#fee2e2",
                                    borderColor: "#fca5a5",
                                    color: "#dc2626"
                                  }
                                }}
                                onClick={() => {
                                  const companyId = String(x._id);
                                  setIsDeleteModalOpen(true);
                                  setId(companyId);
                                  deleteCompanyIdRef.current = companyId;
                                }}
                                title="Delete Company"
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </Table>
                </TableContainer>
              )}
            </Box>
          )}

          <Dialog 
            fullWidth 
            maxWidth="sm" 
            open={open} 
            onClose={handleCloses}
            PaperProps={{
              sx: {
                borderRadius: 2,
                boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
              }
            }}
          >
            <Box sx={{ 
              padding: 3,
              textAlign: "center"
            }}>
              <Typography sx={{
                fontSize: "18px",
                fontWeight: 600,
                fontFamily: "Inter, sans-serif",
                color: "#1f2937",
                marginBottom: 2
              }}>
                Set Default Amount
              </Typography>
              
              <Box sx={{ marginBottom: 3 }}>
                <input
                  type="number"
                  value={defaultAmount}
                  min={0}
                  placeholder="Enter default amount"
                  onChange={(e) => setDefaultAmount(e.target.value)}
                  style={{
                    width: "100%",
                    height: "44px",
                    border: `2px solid ${error ? "#ef4444" : "#e5e7eb"}`,
                    borderRadius: "8px",
                    fontFamily: "Inter, sans-serif",
                    fontSize: "14px",
                    padding: "0 12px",
                    outline: "none",
                    transition: "border-color 0.2s",
                  }}
                  onFocus={(e) => {
                    if (!error) e.target.style.borderColor = "#445fd2";
                  }}
                  onBlur={(e) => {
                    if (!error) e.target.style.borderColor = "#e5e7eb";
                  }}
                />
                {error && (
                  <Typography sx={{ 
                    color: "#ef4444", 
                    fontSize: "12px",
                    fontFamily: "Inter, sans-serif",
                    marginTop: 1,
                    textAlign: "left"
                  }}>
                    Please enter a valid amount
                  </Typography>
                )}
              </Box>
              
              <Box sx={{
                display: "flex",
                gap: 2,
                justifyContent: "center"
              }}>
                <Button
                  onClick={handleCloses}
                  sx={{
                    backgroundColor: "#f3f4f6",
                    color: "#374151",
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 500,
                    textTransform: "none",
                    padding: "8px 24px",
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "#e5e7eb",
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleSave}
                  sx={{
                    backgroundColor: "#445fd2",
                    color: "#fff",
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 500,
                    textTransform: "none",
                    padding: "8px 24px",
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "#3a52c4",
                    },
                  }}
                >
                  Save Amount
                </Button>
              </Box>
            </Box>
          </Dialog>

          <Box sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: 3,
            marginBottom: 2,
          }}>
            <StyledPagination
              size="medium"
              count={initialPaginationCount}
              color="primary"
              showFirstButton
              showLastButton
              page={currentPage}
              onChange={handlePageChange}
            />
          </Box>
        </div>
      </Box>
      <Popup
        openPopup={isOpen}
        popupTitle="Edit : Product Details"
        popupContent={content}
        handleClose={() => {
          setIsOpen(false);
        }}
      />
      <CommonDelete
        open={isDeleteModalOpen}
        onClose={handleClose}
        onDelete={handleDelete}
        text="Are you sure you want to delete this Company?"
        ButtonLabel="Delete"
        cancelButtonLabel="Cancel"
      />
      {/* MFA step: a 6-digit code emailed to the admin is required to delete. */}
      <Dialog
        open={otpModalOpen}
        onClose={() => {
          if (!otpVerifying) {
            setOtpModalOpen(false);
            setOtpValue("");
          }
        }}
        maxWidth="xs"
        fullWidth
      >
        <Box sx={{ p: 3, textAlign: "center" }}>
          <Typography sx={{ fontWeight: 600, fontSize: "16px", mb: 1 }}>
            Verify to delete this company
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#666", mb: 2 }}>
            For security, deleting a company requires a verification code.
            {otpMaskedEmail
              ? ` We emailed a 6-digit code to ${otpMaskedEmail}.`
              : " We emailed a 6-digit code to your registered admin email."}
          </Typography>
          <TextField
            autoFocus
            fullWidth
            value={otpValue}
            onChange={(e) =>
              setOtpValue(e.target.value.replace(/\D/g, "").slice(0, 6))
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                confirmDeleteWithOtp();
              }
            }}
            placeholder="Enter 6-digit code"
            inputProps={{
              inputMode: "numeric",
              maxLength: 6,
              style: {
                textAlign: "center",
                letterSpacing: "6px",
                fontSize: "20px",
              },
            }}
            sx={{ mb: 2 }}
          />
          <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
            <Button
              variant="contained"
              color="error"
              onClick={confirmDeleteWithOtp}
              disabled={otpVerifying || otpValue.length !== 6}
            >
              {otpVerifying ? (
                <CircularProgress size={20} sx={{ color: "#fff" }} />
              ) : (
                "Verify & Delete"
              )}
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setOtpModalOpen(false);
                setOtpValue("");
              }}
              disabled={otpVerifying}
            >
              Cancel
            </Button>
          </Box>
          <Button
            size="small"
            onClick={() => requestDeleteOtp({ resend: true })}
            disabled={otpSending || otpResendIn > 0}
            sx={{ mt: 1.5, textTransform: "none" }}
          >
            {otpResendIn > 0
              ? `Resend code in ${otpResendIn}s`
              : otpSending
                ? "Sending..."
                : "Resend code"}
          </Button>
        </Box>
      </Dialog>
    </Paper>
  );
};

export default CompanyListing;

const TypoStyle = {
  fontFamily: "Inter, sans-serif",
  fontWeight: 500,
  fontSize: "13px",
  color: "#374151",
  marginBottom: "6px",
  display: "block",
};

const empty = {
  color: "#6b7280",
  fontFamily: "Inter, sans-serif",
  fontSize: "16px",
  fontWeight: 400,
  marginTop: 2,
  textAlign: "center",
};

const setBox = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  minHeight: "400px",
  backgroundColor: "#fafbfc",
  padding: 4,
};

const TableTitleStyle = {
  fontFamily: "Inter, sans-serif",
  fontWeight: 600,
  fontSize: "13px",
  color: "#374151",
  backgroundColor: "#f9fafb",
  borderBottom: "2px solid #e5e7eb",
  padding: "12px 16px",
  whiteSpace: "nowrap",
};

const TextStyleCommon = {
  fontFamily: "Inter, sans-serif",
  fontWeight: 400,
  fontSize: "13px",
  color: "#6b7280",
  padding: "12px 16px",
  borderBottom: "1px solid #f3f4f6",
  verticalAlign: "middle",
};

const TableContainerStyle = {
  maxHeight: "calc(100vh - 300px)",
  overflowY: "auto",
  border: "1px solid #e5e7eb",
  borderRadius: "8px",
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#f1f5f9",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#cbd5e1",
    borderRadius: "3px",
    "&:hover": {
      backgroundColor: "#94a3b8",
    },
  },
};

const TypographyComponent = ({ children }) => {
  return (
    <TableCell sx={{ ...TextStyleCommon, borderBottom: "1px solid #f3f4f6" }}>
      <Typography sx={{ fontFamily: "Inter, sans-serif", fontSize: "13px", color: "#6b7280" }}>
        {children}
      </Typography>
    </TableCell>
  );
};
